exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:fibraultrabold_it;font-display:block;src:url(\"/src/fonts/fibra/los_andes_-_fibra_ultrabold_it-webfont.woff2\") format(\"woff2\"),url(\"/src/fonts/fibra/los_andes_-_fibra_ultrabold_it-webfont.woff\") format(\"woff\");font-weight:400;font-style:normal}.footer{position:relative;width:100%;height:50vh}.footer-bg{position:absolute;width:100%;height:100%;background-color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-264b6b45","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Footer.vue
// module id = 47
// module chunks = 0